import { render, staticRenderFns } from "./delete-year.vue?vue&type=template&id=b16fde62&scoped=true"
import script from "./delete-year.vue?vue&type=script&lang=js"
export * from "./delete-year.vue?vue&type=script&lang=js"
import style0 from "./delete-year.vue?vue&type=style&index=0&id=b16fde62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16fde62",
  null
  
)

export default component.exports